import FeedTabs from 'Components/common/tabs/Tabs';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import FilterPopOverWithCompany from 'Components/common/components/FilterPopOverWithCompany';
import HeatMapProgress from 'Components/common/components/HeatMapProgress';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import { actions } from 'Slice/ServiceLinesSlice';
import {
  allKeysHaveLengthInArray,
  allValueInKeyOfArrayExists, getId, getLocalStorageObject, isGenpact, IsMobile, IsMobileSm, IsTablet, toLowerCaseWithoutSpace,
  valueToObject,
} from 'Utils/UtilityFunctions';
import GlobalButton from 'Components/common/components/GlobalButton';
import { useEffect, useMemo, useState, useRef } from 'react';

import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import { Modal, Row } from 'antd';
import { Article } from 'Types/ArticleTypes';
import {
  selectArticleNewsEnded,
  selectFollowLoading,
  selectNewsArticles,
  selectNewsFilter,
  selectNewsLoading,
  selectNewsTabPage,
  selectPaginationLoader,
  selectSelectedNewsFilter,
  selectServicelineName,
  selectServicelineAdded,
  selectWidgetLoading,
  selectServicelineWidgets,
  selectServicelineFilters,
  selectServicelineFiltersType,
  selectServicelineSelectedRegions,
} from 'Selector/ServiceLinesSelector';

import { ServiceLine, SLFilterType, Widget } from 'Types/ServiceLinesTypes';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Column } from 'Pages/person/Favorites';
import styled from 'styled-components';
import NoDataFound from 'Components/common/components/NoDataFound';
import { Filter } from 'Types/FilterTypes';
import {
  SLALERTS, SLCOMPANIES,
  NEWS,
  NODATABASEDONFILTERS, NODATAFOUND, WIDGET,
} from 'Utils/Constants';
import SubNavBarPrimary from 'Components/layout/headers/SubNavBarPrimary';
import classNames from 'classnames';
import NewsTab from 'Components/servicelines/NewsTab';
import _ from 'lodash';
import { ViewInterface } from 'Types/GlobalTypes';
import { selectViewTab } from 'Selector/UISelector';
import ViewTabs from 'Components/common/tabs/ViewTabs';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import GlobalSearch from '../../Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from '../../Components/alerts/components/DrawerAlerts';
import NavBarPrimary from '../../Components/layout/headers/NavBarPrimary';
import { actions as UiAction } from '../../Slice/UISlice';
import { actions as flurryActions } from '../../Slice/HelperSlice';
import { selectKPMGFlag, selectServiceLinePermission } from 'Selector/GlobalSearchContentSelector';
import SRIDropdownFilter from '../../Components/sri/SRIDropdownFilter';
import ServiceLinesDropdownFilter from '../../Components/servicelines/ServiceLinesDropdownFilter';
import AlertsSearch from '../../Components/alerts/components/AlertsSearch';
import SLAddCompanyModal from '../../Components/servicelines/SLAddCompanyModal';
import CompaniesSvg from '../../Components/layout/assets/CompaniesSvg';
import SLRegions from '../../Components/servicelines/SLRegions';
import SLCustomDateFilter from '../../Components/servicelines/SLCustomDateFilter';

const NewsSection = styled.div`
  margin-top: 20px;
`;

const ServiceLinesDetailPage = function ServiceLinesDetailPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id: number = getId();
  const followLoading = useSelector(selectFollowLoading);
  const [nav, setNavArray] = useState<string[]>([]);
  const newsArticles: Article[] = useSelector(selectNewsArticles);
  const articleEnded: boolean = useSelector(selectArticleNewsEnded);
  const page: number = useSelector(selectNewsTabPage);
  const newsFilters: SLFilterType[] = useSelector(selectNewsFilter);
  const selectedNewsFilters: SLFilterType[] = useSelector(selectSelectedNewsFilter);
  const [filters, setFilters] = useState<SLFilterType[]>([]);
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<SLFilterType[]>([]);
  const [customFilters, setCustomFilters] = useState<SLFilterType[]>([]);
  const [customInitialized, setCustomInitialized] = useState<boolean>(false);
  const [previousCustomNewsFiltersApplied, setPreviousCustomNewsFiltersApplied] = useState<SLFilterType[]>([])
  const [selectAllAllert, setSelectAllAlert] = useState<boolean>(true);
  const [selectAllAccount, setSelectAllAccount] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const isPagination: boolean = useSelector(selectPaginationLoader);

  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';

  const loadingWidget: boolean = useSelector(selectWidgetLoading);
  const loadingNews: boolean = useSelector(selectNewsLoading);
  const serviceLinePermission = useSelector(selectServiceLinePermission);
  const KPMGFlag = useSelector(selectKPMGFlag);
  const name: string = useSelector(selectServicelineName);
  const added: boolean = useSelector(selectServicelineAdded);
  const serviceLineWidgets: Widget[] = useSelector(selectServicelineWidgets);
  const isTab = IsTablet();
  const isMob = IsMobile();
  const isMobSm = IsMobileSm();
  const dateFilters = useSelector(selectServicelineFilters);
  const dateFiltersType = useSelector(selectServicelineFiltersType);
  const host = window.location.href;
  const dateRangeFilter = dateFilters?.start_date && dateFilters?.end_date && dateFiltersType ? {
    start_date: dateFilters.start_date,
    end_date: dateFilters.end_date,
    type: dateFiltersType,
    ...(dateFilters.allTime && { allTime: dateFilters.allTime }),
  } : null;
  const pageLoading = loadingNews || loadingWidget;
  const [canShowHeader, setCanShowHeader] = useState(false);
  /** Show header only after 2s delay + API response - prevents flash of stale/wrong content on land or tab switch */
  const headerReady = canShowHeader && name !== '';
  const selectedRegions = useSelector(selectServicelineSelectedRegions);
  const subRegions = selectedRegions.join(",");

  type TabsInterface = {
    [key: string]: string
  };

  type Params = {
    section: string
  };
  const { section } = useParams<Params>();

  const [tabs, setTabs] = useState<TabsInterface>({});

  const activeWidget = (widgets: Widget[]) => widgets?.find(
    (widget) => toLowerCaseWithoutSpace(widget.title) === section,
  );

  useEffect(() => {
    setCanShowHeader(false);
    const timer = setTimeout(() => setCanShowHeader(true), 2000);
    return () => clearTimeout(timer);
  }, [id, section]);

  useEffect(() => {
    if (section === NEWS) {
      const params = {
        id,
        page: 1,
        ...(filters.length > 0 && { filters }),
        ...(dateRangeFilter && { dateRangeFilter }),
        ...(KPMGFlag && { kpmgMode: true }),
        ...(subRegions && { regions: subRegions }),
        ...(customFilters.length > 0 && { customFilters })
      };
      dispatch(actions.getServiceLineDetails(params));
    } else {
      const params = {
        id,
        ...(KPMGFlag && { kpmgMode: true }),
      };
      dispatch(actions.getServiceLineWidgets(params));
    }
  }, []);

  useEffect(() => {
    if (!loadingNews || !loadingWidget) {
      if (serviceLineWidgets.length > 0) {
        if (!serviceLinePermission) {
          navigate('/feed');
        }
      }
    }
  }, [serviceLineWidgets]);

  function setSelectAll(filter: Filter[]) {
    const alertFilters = filter?.filter((item) => item.filterTypeName === SLALERTS);
    const accountFilters = filter?.filter((item) => item.filterTypeName === SLCOMPANIES);
    setSelectAllAlert(allValueInKeyOfArrayExists(alertFilters, 'isSelected', true));
    setSelectAllAccount(allValueInKeyOfArrayExists(accountFilters, 'isSelected', true));
  }

  useEffect(() => {
    if (section === NEWS) {
      if (selectedNewsFilters.length > 1) {
        setFilters(selectedNewsFilters || []);
        setSelectAll(selectedNewsFilters || []);
      } else {
        setFilters(newsFilters || []);
        setPreviousNewsFiltersApplied(newsFilters || []);
        setSelectAll(newsFilters || []);
      }
    } else {
      const active = activeWidget(serviceLineWidgets);
      if (active) {
        if (!KPMGFlag) {
          const { selectedFilters, newsFilters: widgetFilter } = active;
          if (selectedFilters?.length > 1) {
            setFilters(selectedFilters || []);
            setPreviousNewsFiltersApplied(selectedFilters || []);
            setSelectAll(selectedFilters || []);
          } else {
            setFilters(widgetFilter || []);
            setPreviousNewsFiltersApplied(widgetFilter || []);
            setSelectAll(widgetFilter || []);
          }
        } else {
          const { customNewsFilter } = active;
          setCustomFilters(customNewsFilter || []);
          setPreviousCustomNewsFiltersApplied(customNewsFilter || []);
          setSelectAll(customNewsFilter || []);
        }
      }
    }
  }, [newsFilters, serviceLineWidgets, section]);

  const followServiceline = () => {
    // Prevent multiple rapid clicks
    if (followLoading) return;

    const obj: ServiceLine = {
      id,
      image: '',
      name,
      selected: false,
      added: false,
      pagination: false,
      type: 'detailPage',
    };
    dispatch(actions.addingServiceLine(obj));
  };

  useEffect(() => {
    if (!allKeysHaveLengthInArray(serviceLineWidgets, 'selectedFilters')) {
      const navArray: string[] = [];
      if (serviceLineWidgets?.length) {
        serviceLineWidgets.forEach((widget) => {
          navArray.push(widget.title);
        });
      }
      setNavArray(navArray);
    }
    return () => {
      setNavArray([]);
    };
  }, [serviceLineWidgets]);

  useEffect(() => {
    nav?.forEach((item) => setTabs((prevState) => ({
      ...prevState,
      [toLowerCaseWithoutSpace(item)]: item,
    })));
  }, [nav]);

  useEffect(() => {
    if (!_.isEmpty(tabs) && section && section !== NEWS) {
      const tabKeys = Object.keys(tabs);
      // Check if the current section matches any of our tab keys
      const isCurrentSectionValid = tabKeys.includes(section);

      // If current section is not valid and we have tabs, navigate to the first tab
      if (!isCurrentSectionValid && tabKeys.length > 0) {
        const firstTab = tabKeys[0];
        const navLink = `/serviceline/${firstTab}?id=${id}&name=${name}`;
        navigate(navLink, { replace: true });
      }
    }
  }, [tabs, section, id, name, navigate]);

  const onChangeCustomFilter = (flag: boolean, filterId: string) => {
    const updated = customFilters.map((item) => {
      if (item.filterId !== filterId) return item;

      return {
        ...item,
        isSelected: flag,
        subFilters: (item.subFilters || []).map((sub) => ({
          ...sub,
          isSelected: flag,
        }))
      };
    });
    setCustomFilters(updated);
    setSelectAll(updated);
  }

  const onChangeCustomSubFilter = (
    flag: boolean,
    filterId: string,
    subId: string,
  ) => {
    const updated = customFilters.map((item) => {
      if (item.filterId !== filterId) return item;

      const updatedSubFilters = (item.subFilters || []).map((sub) =>
        sub.id === subId ? { ...sub, isSelected: flag } : sub
      );

      const allSelected = updatedSubFilters.every((s) => s.isSelected);
      const noneSelected = updatedSubFilters.some((s) => !s.isSelected);

      return {
        ...item,
        subFilters: updatedSubFilters,
        isSelected: allSelected ? true : noneSelected ? false : item.isSelected,
      };
    });

    setCustomFilters(updated);
    setSelectAll(updated);
  }

  const onChangeFilters = (flag: boolean, idx: string) => {
    if (KPMGFlag) {
      const tempFilters = customFilters.map((filter) => {
        if (filter.filterId === idx) {
          return { ...filter, isSelected: flag };
        } return filter;
      });
      setCustomFilters(tempFilters);
      setSelectAll(tempFilters);
    } else {
      const tempFilters = filters.map((filter) => {
        if (filter.filterId === idx) {
          return { ...filter, isSelected: flag };
        } return filter;
      });
      setFilters(tempFilters);
      setSelectAll(tempFilters);
    }
  };

  const selectOrUnselectAllAlert = (flag: boolean) => {
    if (KPMGFlag) {
      const tempFilters = customFilters.map((filter) => {
        if (filter.filterTypeName !== SLALERTS) return filter;

        return {
          ...filter,
          isSelected: flag,
          subFilters: (filter.subFilters || []).map((sub) => ({
            ...sub,
            isSelected: flag,
          })),
        };
      });
      setCustomFilters(tempFilters);
    } else {
      const tempFilters = filters.map(
        (filter) => (filter.filterTypeName === SLALERTS
          ? { ...filter, isSelected: flag } : filter),
      );
      setFilters(tempFilters);
    }
  };

  const selectOrUnselectAllAccount = (flag: boolean) => {
    if (KPMGFlag) {
      const tempFilters = customFilters.map(
        (filter) => (filter.filterTypeName === SLCOMPANIES
          ? { ...filter, isSelected: flag } : filter),
      );
      setCustomFilters(tempFilters);

    } else {
      const tempFilters = filters.map(
        (filter) => (filter.filterTypeName === SLCOMPANIES
          ? { ...filter, isSelected: flag } : filter),
      );
      setFilters(tempFilters);
    }
  };

  const onClickHandlerAlert = () => {
    selectOrUnselectAllAlert(!selectAllAllert);
    setSelectAllAlert(!selectAllAllert);
  };

  const onClickHandlerAccount = () => {
    selectOrUnselectAllAccount(!selectAllAccount);
    setSelectAllAccount(!selectAllAccount);
  };

  const applyFilterHandler = () => {
    const params = {
      page: 1,
      id,
      ...(filters.length > 0 && { filters }),
      ...(dateRangeFilter && { dateRangeFilter }),
      ...(KPMGFlag && { kpmgMode: true }),
      ...(subRegions && { regions: subRegions }),
      ...(customFilters.length > 0 && { customFilters })
    };
    const active = activeWidget(serviceLineWidgets);
    if (section === NEWS) {
      dispatch(actions.getServiceLineDetails(params));
    } else {
      dispatch(actions.getServiceLineDetails({
        ...params,
        widget_name: active?.title,
      }));
    }
    setPreviousNewsFiltersApplied(filters);
  };

  const checkForApplyFilter = () => {
    for (let i = 0; i < filters?.length; i += 1) {
      if (filters[i].isSelected !== previousNewsFiltersApplied[i]?.isSelected) return false;
    }
    return true;
  };

  const fetchArticles = () => {
    const params = {
      page,
      id,
      ...(filters.length > 0 && { filters }),
      ...(dateRangeFilter && { dateRangeFilter }),
      ...(KPMGFlag && { kpmgMode: true }),
      ...(subRegions && { regions: subRegions }),
      ...(customFilters.length > 0 && { customFilters })
    };
    dispatch(actions.getServiceLineDetails(params));
  };

  const fetchMore = () => {
    if (newsArticles?.length > 0) {
      fetchArticles();
    }
  };

  useEffect(() => {
    if (!loadingNews && !loadingWidget && !filters?.length && !customFilters.length) setShowFilter(false);
    else setShowFilter(true);
  }, [loadingNews, loadingWidget, filters, customFilters]);

  useEffect(() => {
    // Initialize view from localStorage on mount
    const savedView = getLocalStorageObject('ViewTab') as ViewInterface;
    if (savedView?.view) {
      dispatch(UiAction.isTabView({
        view: savedView.view,
      }));
    }
  }, []);

  const addCompanyBtnClick = () => {
    setShowModal(true);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('serviceLines_add_clicked', 0,)
    ));

  };
  return (
    <>
      <NavBarPrimary headerClassName="no-overflow-on-header">
        <div className="left-side-wrap service-lines-left-wrap">
          <BackIcon onClick={() => navigate(-1)} />
          {!headerReady ? <SkeletonCustom width="340px" height="30px" margin="0px 0px 0px 5px" /> : <h1 className="heading text-truncate-one-line">{name}</h1>}
          {headerReady ? (
            <div>
              {!added && !isMob ? (
                <div className="global-btn-industries">
                  <GlobalButton
                    title={!followLoading ? 'Follow' : 'Following'}
                    textColor="#ffffff"
                    bgColor="#001760"
                    borderRadius="25px"
                    PaddingSm="0px 16px"
                    heightSm="25px"
                    height="30px"
                    LeftSpace="10px"
                    buttonClassName="button-follow"
                    disabled={followLoading}
                    onButtonClick={followServiceline}
                  />
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={isTab} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>
      </NavBarPrimary>
      <SubNavBarPrimary>
        <div className='service-lines-top-header'>
          <div className={classNames('view-tabs', {
            notdisabledTabs: true,
          })}
          >
            <ViewTabs
              disabled={false}
              listView={isListView}
            />
          </div>
          <div className="heading-inner-page tabs-placeholder  wrap-slider hidden-scroll">
            <div className="head-wrap" />
            {headerReady ? (
              <div className="global-btn-industries sub-primary-nav-follow">
                {!added && isMob ? (
                  <GlobalButton
                    title={!followLoading ? 'Follow' : 'Following'}
                    textColor="#ffffff"
                    bgColor="#001760"
                    borderRadius="8px"
                    PaddingSm="0px 16px"
                    heightSm="25px"
                    height="30px"
                    LeftSpace="10px"
                    buttonClassName="button-follow"
                    disabled={followLoading}
                    onButtonClick={followServiceline}
                  />
                ) : null}
              </div>
            ) : null}
            {
              !KPMGFlag && (
                <div className="tips-placeholder d-flex justify-content-center">
                  <FeedTabs scrollStartToWindow baseComponentPath="serviceline" tabsName={nav} loading={loadingWidget || loadingNews} elementTarget="tabs-details" headerAppendTab />
                </div>
              )
            }
            <div className="right-side-sub-header">
              {
                KPMGFlag && (
                  <SLRegions
                    serviceLineId={id}
                    filter={filters}
                    {...(dateRangeFilter && { dateRangeFilter })}
                    widgetName={tabs[section?.toLowerCase() ?? '']}
                    page={page}
                    customFilters={customFilters}
                  />
                )
              }
              {KPMGFlag && section && section !== NEWS && tabs[section?.toLowerCase()] ? (
                <div className={classNames('date-range-picker serviceLines')}>
                  <SLCustomDateFilter
                    serviceLineId={id}
                    filter={filters}
                    widgetName={tabs[section?.toLowerCase() ?? '']}
                    name={name}
                    customFilters={customFilters}
                  />
                </div>
              ) : null}
              <div className={classNames('filter-placeholder serviceLines', {
                notDisabledFilter: showFilter,
              })}
              >
                <FilterPopOverWithCompany
                  loading={pageLoading}
                  filters={filters}
                  customFilters={customFilters}
                  selectAllAllert={selectAllAllert}
                  selectAllAccount={selectAllAccount}
                  onChangeFilters={onChangeFilters}
                  onChangeCustomFilters={onChangeCustomFilter}
                  onChangeCustomSubFilters={onChangeCustomSubFilter}
                  onClickHandlerAlert={onClickHandlerAlert}
                  onClickHandlerAccount={onClickHandlerAccount}
                  applyFilterHandler={applyFilterHandler}
                  KPMGFlag={KPMGFlag}
                  iconMode={isTab}
                />
              </div>
              {
                KPMGFlag && (
                  <>
                    <div className={classNames('add-company serviceLines')}>
                      <span
                        className='add-company-btn'
                        role='button'
                        onClick={addCompanyBtnClick}
                      >
                        {
                          !isTab ? (
                            <span className='text'>Manage Company</span>
                          ) : (
                            <span className='icon'><CompaniesSvg color='#fff' /></span>
                          )
                        }
                      </span>
                    </div>
                    {
                      showModal && (
                        <SLAddCompanyModal
                          setShowModal={setShowModal}
                          showModal={showModal}
                          serviceLineId={id}
                          widgetName={tabs[section?.toLowerCase() ?? '']}
                          filters={filters}
                        />
                      )
                    }
                  </>
                )
              }
            </div>
          </div>
        </div>

      </SubNavBarPrimary>
      <div className="container">
        {section !== NEWS && (loadingWidget || loadingNews) && _.isEmpty(tabs)
          ? (
            <div className="mt-c-15">
              <Row gutter={[16, 16]}>
                {isListView ? (
                  <ArticleListLoadingSkeletonBundle />
                ) : (
                  <ArticleLoadingSkeletonBundle />
                )}
              </Row>
            </div>
          ) : ''}
        {section === NEWS ? (
          <NewsSection>
            {loadingNews
              ? (
                <Row gutter={[16, 16]}>
                  {isListView ? (
                    <ArticleListLoadingSkeletonBundle />
                  ) : (
                    <ArticleLoadingSkeletonBundle />
                  )}
                </Row>
              )
              : (
                <>
                  <div>
                    <InfiniteScroll
                      dataLength={newsArticles.length}
                      next={fetchMore}
                      hasMore={!articleEnded}
                      loader={false}
                      className="o-x-hidden o-y-hidden"
                    >

                      {!loadingNews && newsArticles.length > 0
                        ? (
                          <ArticleGridLayout
                            articlesArray={newsArticles}
                            listview={isListView}
                            isLoading={isPagination}
                          />
                        )
                        : !loadingNews && newsArticles.length === 0 ? (
                          <Column span={24} className="article-grid width-100">
                            <NoDataFound title={`${selectedNewsFilters?.length ? NODATABASEDONFILTERS : NODATAFOUND}`} />
                          </Column>
                        ) : null}
                    </InfiniteScroll>
                  </div>
                  {
                    isPagination && !articleEnded && (
                      <Row gutter={[16, 16]}>
                        {isListView ? (
                          <ArticleListLoadingSkeletonBundle />
                        ) : (
                          <ArticleLoadingSkeletonBundle />
                        )}
                      </Row>
                    )
                  }
                </>
              )}
          </NewsSection>
        ) : null}
        <div className="mt-c-10">
          <HeatMapProgress pulse={[]} />
        </div>
        {section && section !== NEWS && tabs[section?.toLowerCase()] ? (
          <NewsTab
            id={id}
            listview={isListView}
            widgetName={tabs[section?.toLowerCase()]}
            {...(dateRangeFilter && { dateRangeFilter })}
            pageLoading={pageLoading}
            customFilters={customFilters}
          />
        ) : null}
      </div>
    </>
  );
};

export default ServiceLinesDetailPage;